import {
  NotListedCompanyOwnershipStructure,
  PublicCompanyOwnershipStructure,
  ThirdSectorOwnershipStructureId
} from '../helpers/statistics/index'

interface Option {
  id: string
  value: string
  country?: string
}

interface Collection {
  id: string // Controls the field on the Company entity used for the value of this collection
  fieldParent?: string // If defined, the value of this collection is found at Company[fieldParent][id] instead of just Company[id]
  value: string
}

interface OwnershipStructure {
  country: string
  value: string
  id: string
}

export const Collections: Collection[] = [
  { id: 'sector', value: 'Sector' },
  { id: 'employeeCount', value: 'Employee Count' },
  { id: 'ownershipStructure', value: 'Ownership Structure' },
  { id: 'country', fieldParent: 'address', value: 'Country' },
  { id: 'marketCap', value: 'Market Cap' }
]

export const EmployeeCountOptions = [
  {
    value: '1 - 10',
    id: '1To10'
  },
  {
    value: '11 - 50',
    id: '10To50'
  },
  {
    value: '51 - 250',
    id: '50To250'
  },
  {
    value: '251 - 500',
    id: '250To500'
  },
  {
    value: '501 - 1,000',
    id: '500To1k'
  },
  {
    value: '1,001 - 5,000',
    id: '1kTo5k'
  },
  {
    value: '5,001 - 10,000',
    id: '5kTo10k'
  },
  {
    value: '10,001 - 50,000',
    id: '10kTo50k'
  },
  {
    value: '50,001 - 1,000,000',
    id: '50kTo1m'
  },
  {
    value: 'More than 1,000,000',
    id: '1mPlus'
  }
]

export const SectorOptions = [
  {
    value: 'Advanced Electronics',
    id: 'AdvancedElectronics'
  },
  {
    value: 'Aerospace & Defense',
    id: 'Aerospace'
  },
  {
    value: 'Agriculture',
    id: 'Agriculture'
  },
  {
    value: 'Automotive & Assembly',
    id: 'AutomotiveAssembly'
  },
  {
    value: 'Capital Project & Infrastructure',
    id: 'CapitalProjectInfrastructure'
  },
  {
    value: 'Chemicals',
    id: 'Chemicals'
  },
  {
    value: 'Consumer Packaged Goods',
    id: 'ConsumerPackagedGoods'
  },
  {
    value: 'Electronic Power & Natural Gas',
    id: 'ElectronicPowerGas'
  },
  {
    value: 'Utilities',
    id: 'Utilities'
  },
  {
    value: 'Financial Services',
    id: 'FinancialServices'
  },
  {
    value: 'Healthcare Systems & Services',
    id: 'HealthcareSystems'
  },
  {
    value: 'Industrial Products & Construction',
    id: 'IndustrialProductsConstruction'
  },
  {
    value: 'Insurance',
    id: 'Insurance'
  },
  {
    value: 'Manufacturing & Engineering',
    id: 'ManufacturingEngineering'
  },
  {
    value: 'Metals & Mining',
    id: 'MetalsMining'
  },
  {
    value: 'Mutuals',
    id: 'Mutuals'
  },
  {
    value: 'Oil & Gas',
    id: 'OilGas'
  },
  {
    value: 'Paper, Forest Products & Packaging',
    id: 'PaperForestPackaging'
  },
  {
    value: 'Pharmaceuticals & Medical Products',
    id: 'Pharmaceuticals'
  },
  {
    value: 'Primary and Secondary Education',
    id: 'PrimarySecondaryEducation'
  },
  {
    value: 'Private Equity & Principal Investors',
    id: 'PrivateEquity'
  },
  {
    value: 'Professional Services',
    id: 'ProfessionalServices'
  },
  {
    value: 'Public Sector',
    id: 'PublicSector'
  },
  {
    value: 'Real Estate',
    id: 'RealEstate'
  },
  {
    value: 'Renewables & Environment',
    id: 'RenewablesEnvironment'
  },
  {
    value: 'Retail',
    id: 'Retail'
  },
  {
    value: 'Semiconductors',
    id: 'SemiConductors'
  },
  {
    value: 'Social Sector',
    id: 'SocialSector'
  },
  {
    value: 'Software & Computing',
    id: 'SoftwareComputing'
  },
  {
    value: 'Technology, Media & Telecommunication',
    id: 'TechnologyMedia'
  },
  {
    value: 'Travel, Transport & Logistics',
    id: 'TravelTransportLogistics'
  }
]

export const OwnershipStructureOptions: OwnershipStructure[] = [
  {
    country: 'UK',
    value: 'FTSE 100',
    id: 'FTSE100'
  },
  {
    country: 'UK',
    value: 'FTSE 250',
    id: 'FTSE250'
  },
  {
    country: 'UK',
    value: 'FTSE 350',
    id: 'FTSE350'
  },
  {
    country: 'UK',
    value: 'FTSE Small Cap',
    id: 'FTSESmallCap'
  },
  {
    country: 'UK',
    value: 'AIM Market',
    id: 'AIMMarket'
  },
  {
    country: 'Germany',
    value: 'DAX40',
    id: 'DAX40'
  },
  {
    country: 'Germany',
    value: 'MDAX',
    id: 'MDAX'
  },
  {
    country: 'Germany',
    value: 'TecDAX',
    id: 'TecDAX'
  },
  {
    country: 'Germany',
    value: 'Öko',
    id: 'Öko'
  },
  {
    country: 'Austria',
    value: 'ATX',
    id: 'ATX'
  },
  {
    country: 'Switzerland',
    value: 'SMI CH20',
    id: 'SMICH20'
  },
  {
    country: 'Switzerland',
    value: 'SIX Swiss Exchange',
    id: 'SSIRT'
  },
  {
    country: 'Europe',
    value: 'EURO STOXX 50',
    id: 'EUROSTOXX50'
  },
  {
    country: 'Belgium',
    value: 'BEL 20',
    id: 'BEL20'
  },
  {
    country: 'Belgium',
    value: 'BEL Mid',
    id: 'BELMid'
  },
  {
    country: 'Belgium',
    value: 'BEL Small',
    id: 'BELSmall'
  },
  {
    country: 'Netherlands',
    value: 'SDAX Small Cap',
    id: 'SDAXSmallCap'
  },
  {
    country: 'Netherlands',
    value: 'AEX index',
    id: 'AEXindex'
  },
  {
    country: 'Netherlands',
    value: 'AMX index',
    id: 'AMXindex'
  },
  {
    country: 'Netherlands',
    value: 'AScX index',
    id: 'AScXindex'
  },
  {
    country: 'France',
    value: 'CAC 40',
    id: 'CAC40'
  },
  {
    country: 'US',
    value: 'Dow Jones Industrial Average',
    id: 'DowJonesIndustrialAverage'
  },
  {
    country: 'US',
    value: 'NASDAQ-100',
    id: 'NASDAQ-100'
  },
  {
    country: 'US',
    value: 'S&P 500',
    id: 'S&P500'
  },
  {
    country: 'China',
    value: 'HANG SENG',
    id: 'HANGSENG'
  },
  {
    country: 'Africa',
    value: 'Russell 3000',
    id: 'Russell3000'
  },
  {
    country: 'India',
    value: 'JSE',
    id: 'JSE'
  },
  {
    country: 'India',
    value: 'Sensex',
    id: 'Sensex'
  },
  {
    country: 'India',
    value: 'Nifty50',
    id: 'Nifty50'
  },
  {
    country: 'Other',
    value: 'Other',
    id: 'Other'
  },
  {
    country: 'Other',
    value: NotListedCompanyOwnershipStructure.PEBacked,
    id: NotListedCompanyOwnershipStructure.PEBacked
  },
  {
    country: 'Other',
    value: NotListedCompanyOwnershipStructure.VCBacked,
    id: NotListedCompanyOwnershipStructure.VCBacked
  },
  {
    country: 'Other',
    value: NotListedCompanyOwnershipStructure.FamilyOwned,
    id: NotListedCompanyOwnershipStructure.FamilyOwned
  },
  {
    country: 'Other',
    value: NotListedCompanyOwnershipStructure.PrivatelyOwned,
    id: NotListedCompanyOwnershipStructure.PrivatelyOwned
  },
  {
    country: 'Other',
    value: PublicCompanyOwnershipStructure.NHS,
    id: PublicCompanyOwnershipStructure.NHS
  },
  {
    country: 'Other',
    value: PublicCompanyOwnershipStructure.CentralGovernment,
    id: PublicCompanyOwnershipStructure.CentralGovernment
  },
  {
    country: 'Other',
    value: PublicCompanyOwnershipStructure.LocalGovernment,
    id: PublicCompanyOwnershipStructure.LocalGovernment
  },
  {
    country: 'Other',
    value: PublicCompanyOwnershipStructure.HigherEducation,
    id: PublicCompanyOwnershipStructure.HigherEducation
  },
  {
    country: 'Other',
    value: PublicCompanyOwnershipStructure.PrivatePublicServices,
    id: PublicCompanyOwnershipStructure.PrivatePublicServices
  },
  {
    country: 'Other',
    value: 'Third Sector',
    id: ThirdSectorOwnershipStructureId
  }
]

export const CountryOptions = [
  {
    value: 'United Kingdom',
    id: 'UK'
  },
  {
    value: 'Germany',
    id: 'DE'
  },
  {
    value: 'United States of America',
    id: 'US'
  },
  {
    value: 'Switzerland',
    id: 'CH'
  },
  {
    value: 'Argentina',
    id: 'AR'
  },
  {
    value: 'Australia',
    id: 'AU'
  },
  {
    value: 'Austria',
    id: 'AT'
  },
  {
    value: 'Belgium',
    id: 'BE'
  },
  {
    value: 'Bermuda',
    id: 'BM'
  },
  {
    value: 'Brazil',
    id: 'BR'
  },
  {
    value: 'Canada',
    id: 'CA'
  },
  {
    value: 'Chile',
    id: 'CL'
  },
  {
    value: 'China',
    id: 'CN'
  },
  {
    value: 'Colombia',
    id: 'CO'
  },
  {
    value: 'Croatia',
    id: 'HR'
  },
  {
    value: 'Czech Republic',
    id: 'CZ'
  },
  {
    value: 'Denmark',
    id: 'DK'
  },
  {
    value: 'Egypt',
    id: 'EG'
  },
  {
    value: 'Finland',
    id: 'FI'
  },
  {
    value: 'France',
    id: 'FR'
  },
  {
    value: 'Greece',
    id: 'GR'
  },
  {
    value: 'Hungary',
    id: 'HU'
  },
  {
    value: 'India',
    id: 'IN'
  },
  {
    value: 'Indonesia',
    id: 'ID'
  },
  {
    value: 'Italy',
    id: 'IT'
  },
  {
    value: 'Japan',
    id: 'JP'
  },
  {
    value: 'Jordan',
    id: 'JO'
  },
  {
    value: 'Korea',
    id: 'KR'
  },
  {
    value: 'Luxembourg',
    id: 'LU'
  },
  {
    value: 'Malaysia',
    id: 'MY'
  },
  {
    value: 'Malta',
    id: 'MT'
  },
  {
    value: 'Mexico',
    id: 'MX'
  },
  {
    value: 'Moldova',
    id: 'MD'
  },
  {
    value: 'Morocco',
    id: 'MA'
  },
  {
    value: 'Netherlands',
    id: 'NL'
  },
  {
    value: 'Norway',
    id: 'NO'
  },
  {
    value: 'Poland',
    id: 'PL'
  },
  {
    value: 'Portugal',
    id: 'PT'
  },
  {
    value: 'Russia',
    id: 'RU'
  },
  {
    value: 'South Africa',
    id: 'ZA'
  },
  {
    value: 'Spain',
    id: 'ES'
  },
  {
    value: 'Sweden',
    id: 'SE'
  },
  {
    value: 'Tajikistan',
    id: 'TJ'
  },
  {
    value: 'Turkey',
    id: 'TR'
  },
  {
    value: 'United Arab Emirates',
    id: 'AE'
  }
]

export const MarketCapOptions = [
  {
    id: 'NotApplicable',
    value: 'Not Applicable'
  },
  {
    id: 'Sub100m',
    value: '< £100 million'
  },
  {
    id: '100mTo500m',
    value: '£100 million < £500 million'
  },
  {
    id: '500mTo1b',
    value: '£500 million < £1 billion'
  },
  {
    id: '1bTo5b',
    value: '£1 billion < £5 billion'
  },
  {
    id: '5bTo10b',
    value: '£5 billion < £10 billion'
  },
  {
    id: '10bTo25b',
    value: '£10 billion < £25 billion'
  },
  {
    id: '25bTo50b',
    value: '£25 billion < £50 billion'
  },
  {
    id: '50bPlus',
    value: '> £50 billion'
  }
]

function collateOptions (): Option[] {
  return [
    ...CountryOptions,
    ...EmployeeCountOptions,
    ...SectorOptions,
    ...OwnershipStructureOptions,
    ...Collections,
    ...MarketCapOptions
  ]
}

export default function getOption (key: string): Option | undefined {
  const options = collateOptions()
  return options.find((item) => item.id === key)
}
